SlideView           = require("views/slide")
{ Session, Lesson } = Application.actions()
Device              = require "lib/device"

lookupCaseInsensitive = (ob, key) ->
  for k, v of ob
    return ob[k] if k.toLowerCase() is key.toLowerCase()
  return null

lessonPassed = (attemptData) ->
  return lookupCaseInsensitive(attemptData.core, "Lesson_Status")

class AICCView extends SlideView
  template: require("./template")
  events: ->
    "iostap .exit-btn": "onClickContinue"

  initialize: ->
    super

  beforeShow: ->
    position = @options.data.button?.position?.toLowerCase() or "none"
    @setState written.hyphenCase(position), "exit-btn"

    @trigger "ui", { lightbox: @options.data.background or true, fullscreen: true }

    @onResize()

  beforeHide: ->
    @trigger "ui", { lightbox: false, fullscreen: false }

  show: ->
    @listenTo this, "resize", @onResize
    @initAICC (err) ->
      if err?
        console.error("Error while initializing AICC", err)

  onRefresh: ->
    @beforeShow()
    super

  onResize: ->
    if @currentState["exit-btn"] is "below"
      button = @findOne(".exit-btn")
      iframe = @findOne(".scorm-object")

      iframe.style.bottom = "#{button.offsetHeight}px"
      iframe.style.height =
        "#{iframe.parentNode.offsetHeight - button.offsetHeight}px"

  getAttempt: (done) ->
    @getAICCPackageURLAndSID (err, { aiccURL, aiccSID }) ->
      $.ajax
        url: "#{aiccURL}/result"
        type: "POST"
        data: { session_id: aiccSID }
        success: (d) ->
          done(null, d)
        error: (e) ->
          done(e)

  stopAICC: ->
    @getAttempt (err, attempt) =>
      # according to AICC spec keys can be written in any case
      coreAttempt       = lookupCaseInsensitive(attempt, "core") or {}
      attemptCompletion = lookupCaseInsensitive(coreAttempt, "Lesson_Status") or ""
      attemptScore      = lookupCaseInsensitive(coreAttempt, "Score") or "0"

      score       = parseInt(attemptScore) * 0.01

      # According to AICC spec only the first character is significant.
      # We consider "passed" and "completed" both to count, mainly because
      # of mbusa T0628E-US.TTC sending "completed" instead of "passed".
      # This property only matters if *Required Content* is checked in the authoring tool.
      completed   = attemptCompletion.toLowerCase().match(/^[pc]/)?

      Session.get (err, { attempt }) =>
        interaction =
          id:              @options.id
          name:            @options.name
          type:            @options.type
          slideData:       @options.data
          attempt:         attempt
          answerDetails:   []
          metadata:        @options.metadata
          isAiccAttempt:   true
          isCompleted:     completed
          isRequiredForLessonCompletion: @options.data.isRequiredForLessonCompletion
          score:           score
          configuration:   @options.data?.challenge_configuration
          success:         completed

        @lesson.processInteraction(interaction)

        if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
          return
        else if @isLastSlide
          Lesson.complete()
          @exit()
        else
          @next()

  onClickContinue: ->
    @stopAICC()
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
      @next()

  getAICCPackageURLAndSID: (done) ->
    slideId = @options.id
    Session.get (err, { id, userId, attempt, aiccURL }) ->
      return done(err) if err?

      # Id is the lesson id
      lessonId = id
      # We add slide Id to be able to differentiate
      # between 2 AICC slides within the same lesson
      aiccSID = if lessonId
        "#{lessonId}|#{slideId}|#{userId}|#{attempt}"
      else
        "lessonId|slideId||userId|attempt"

      # If the url has not been passed to the session
      # we use the same domain as what is serving the package
      aiccURL = window.location.origin + "/api/aicc" # If not defined

      done(null, { aiccURL, aiccSID })

  serialize: ->
    super

  initAICCResource: (done) ->
    data     = @serialize()
    resource = data.package

    if window.ED_LMS_PREVIEW and (!resource or resource is "about:blank")
      return

    @getAICCPackageURLAndSID (err, { aiccURL, aiccSID }) =>
      return done(err) if err?
      params   = "aicc_url=#{aiccURL}&aicc_sid=#{aiccSID}"
      resource += if resource.match(/\?/)
        if resource.match(/\&$/)
          "#{params}"
        else
          "&#{params}"
      else
        "?#{params}"

      if not(window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW) and data.shouldOpenInPopup
        aiccWindow = window.open(resource)
        pollTimer  = window.setInterval =>
          if aiccWindow.closed isnt false
            window.clearInterval(pollTimer)
            @stopAICC()
        , 200
      else
        @findOne(".scorm-object").src = resource

      done()


  initAICC: (done) ->
    @initAICCResource(done)

module.exports = AICCView
